// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "inference/v1/inference.proto" (package "inference.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal APIs for running LLM inference
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { InferenceService } from "./inference";
import type { InferSceneUpdateResponse } from "./inference";
import type { InferSceneUpdateRequest } from "./inference";
import type { InferModuleCodeResponse } from "./inference";
import type { InferModuleCodeRequest } from "./inference";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { InferQueryResponse } from "./inference";
import type { InferQueryRequest } from "./inference";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service inference.v1.InferenceService
 */
export interface IInferenceServiceClient {
    /**
     * @generated from protobuf rpc: InferQuery(inference.v1.InferQueryRequest) returns (inference.v1.InferQueryResponse);
     */
    inferQuery(input: InferQueryRequest, options?: RpcOptions): UnaryCall<InferQueryRequest, InferQueryResponse>;
    /**
     * @generated from protobuf rpc: InferModuleCode(inference.v1.InferModuleCodeRequest) returns (inference.v1.InferModuleCodeResponse);
     */
    inferModuleCode(input: InferModuleCodeRequest, options?: RpcOptions): UnaryCall<InferModuleCodeRequest, InferModuleCodeResponse>;
    /**
     * @generated from protobuf rpc: InferSceneUpdate(inference.v1.InferSceneUpdateRequest) returns (inference.v1.InferSceneUpdateResponse);
     */
    inferSceneUpdate(input: InferSceneUpdateRequest, options?: RpcOptions): UnaryCall<InferSceneUpdateRequest, InferSceneUpdateResponse>;
}
/**
 * @generated from protobuf service inference.v1.InferenceService
 */
export class InferenceServiceClient implements IInferenceServiceClient, ServiceInfo {
    typeName = InferenceService.typeName;
    methods = InferenceService.methods;
    options = InferenceService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: InferQuery(inference.v1.InferQueryRequest) returns (inference.v1.InferQueryResponse);
     */
    inferQuery(input: InferQueryRequest, options?: RpcOptions): UnaryCall<InferQueryRequest, InferQueryResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<InferQueryRequest, InferQueryResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: InferModuleCode(inference.v1.InferModuleCodeRequest) returns (inference.v1.InferModuleCodeResponse);
     */
    inferModuleCode(input: InferModuleCodeRequest, options?: RpcOptions): UnaryCall<InferModuleCodeRequest, InferModuleCodeResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<InferModuleCodeRequest, InferModuleCodeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: InferSceneUpdate(inference.v1.InferSceneUpdateRequest) returns (inference.v1.InferSceneUpdateResponse);
     */
    inferSceneUpdate(input: InferSceneUpdateRequest, options?: RpcOptions): UnaryCall<InferSceneUpdateRequest, InferSceneUpdateResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<InferSceneUpdateRequest, InferSceneUpdateResponse>("unary", this._transport, method, opt, input);
    }
}
